export default {
    lastUpdated: "Ultimo aggiornamento",
    footer: {
        terms: "Termini e condizioni",
        privacy: "Informativa sulla privacy",
    },
    terms: {
        title: "Termini e condizioni",
        sections: {
            acceptance: {
                title: "1. Accettazione dei termini",
                content:
                    "Accedendo o utilizzando la piattaforma Eve Mind, accetti di essere vincolato da questi Termini e condizioni. Se non accetti una qualsiasi parte di questi termini, non puoi utilizzare i nostri servizi.",
            },
            useOfService: {
                title: "2. Utilizzo del servizio",
                content:
                    "Eve Mind fornisce una piattaforma di gestione del commercio e della logistica. Accetti di utilizzare il servizio solo per scopi leciti e in conformità con questi termini. Sei responsabile della riservatezza delle credenziali del tuo account.",
            },
            accountSecurity: {
                title: "3. Account e sicurezza",
                content:
                    "Devi fornire informazioni accurate e complete nella creazione dell'account. Sei responsabile di tutte le attività che avvengono sotto il tuo account. Comunicaci immediatamente eventuali utilizzi non autorizzati.",
            },
            intellectualProperty: {
                title: "4. Proprietà intellettuale",
                content:
                    "Tutti i contenuti, le funzionalità e le caratteristiche della piattaforma Eve Mind sono di proprietà di Eve Mind e sono protetti dalle leggi internazionali su copyright, marchi e altre leggi sulla proprietà intellettuale.",
            },
            limitationOfLiability: {
                title: "5. Limitazione di responsabilità",
                content:
                    "Nei limiti massimi consentiti dalla legge, Eve Mind non sarà responsabile per danni indiretti, incidentali, speciali, consequenziali o punitivi derivanti dall'uso del servizio.",
            },
            changes: {
                title: "6. Modifiche ai termini",
                content:
                    "Potremmo modificare questi termini in qualsiasi momento. Ti informeremo delle modifiche sostanziali pubblicando i termini aggiornati su questa pagina e aggiornando la data \"Ultimo aggiornamento\". Il proseguimento dell'uso del servizio dopo tali modifiche costituisce accettazione.",
            },
            contact: {
                title: "7. Contatti",
                content:
                    "Per domande su questi Termini e condizioni, contattaci a eve.mind.ai@gmail.com.",
            },
        },
    },
    privacy: {
        title: "Informativa sulla privacy",
        sections: {
            dataWeCollect: {
                title: "1. Dati che raccogliamo",
                content:
                    "Raccogliamo le informazioni che fornisci direttamente (es. dati dell'account, informazioni aziendali), i dati generati dall'uso della piattaforma (es. dati su spedizioni e documenti) e dati tecnici (es. indirizzo IP, tipo di browser) necessari per il funzionamento del servizio.",
            },
            howWeUse: {
                title: "2. Come utilizziamo i dati",
                content:
                    "Utilizziamo i tuoi dati per fornire, mantenere e migliorare la piattaforma Eve Mind, per evadere le tue richieste, per comunicare con te e per adempiere agli obblighi di legge. Non vendiamo i tuoi dati personali a terzi.",
            },
            dataSharing: {
                title: "3. Condivisione dei dati",
                content:
                    "Potremmo condividere i dati con fornitori di servizi che ci supportano nell'erogazione della piattaforma (es. hosting, analisi), con il tuo consenso o quando richiesto dalla legge. Richiediamo a tali fornitori di proteggere adeguatamente i tuoi dati.",
            },
            retention: {
                title: "4. Conservazione",
                content:
                    "Conserviamo i tuoi dati finché il tuo account è attivo o quanto necessario per fornirti i servizi. Potremmo conservare alcuni dati più a lungo quando richiesto dalla legge o per legittimi scopi aziendali.",
            },
            yourRights: {
                title: "5. I tuoi diritti",
                content:
                    "A seconda della tua giurisdizione, potresti avere il diritto di accedere, correggere, cancellare o portare i tuoi dati personali, oppure di opporti o limitare determinate elaborazioni. Contattaci a eve.mind.ai@gmail.com per esercitare questi diritti.",
            },
            cookies: {
                title: "6. Cookie e tecnologie simili",
                content:
                    "Utilizziamo cookie e tecnologie simili per mantenere le sessioni, ricordare le preferenze e analizzare l'utilizzo. Puoi gestire le impostazioni dei cookie dal tuo browser.",
            },
            contact: {
                title: "7. Contatti",
                content:
                    "Per domande su questa Informativa sulla privacy o sulle nostre pratiche in materia di dati, contattaci a eve.mind.ai@gmail.com.",
            },
        },
    },
};
